export default {
  TRAININGS: "Training",
  NAVBAR_TOOLTIP: "Training and help",
  HELP: "Help",
  HELP_FOR: "Help: {topic}",

  CONTEXT_PURCHASES_ORDERS: "Purchase orders",
  CONTEXT_PURCHASES_ORDERS_WHERE:
    "Establishment › Purchase orders · Purchases › Purchase orders",
  CONTEXT_PURCHASES_ORDER_RECEPTION: "Receiving a purchase order",
  CONTEXT_PURCHASES_ORDER_RECEPTION_WHERE: "Purchase order › Confirm reception",
  CONTEXT_SALES_ORDERS: "Quotes",
  CONTEXT_SALES_ORDERS_WHERE: "Establishment › Quotes · Sales › Quotes",
  CONTEXT_CASH_REGISTER_READINGS: "Cash register readings",
  CONTEXT_CASH_REGISTER_READINGS_WHERE: "Sales › Cash register readings",
  CONTEXT_INVENTORY: "Inventory",
  CONTEXT_INVENTORY_WHERE:
    "Inventory › Training · Stock movements · Warehouses",
  CONTEXT_INTERNAL_ORDERS: "Internal orders",
  CONTEXT_INTERNAL_ORDERS_WHERE:
    "Establishment › Internal orders · Inventory › Internal orders",
  CONTEXT_ESTABLISHMENT_TRANSFERS: "Transfers",
  CONTEXT_ESTABLISHMENT_TRANSFERS_WHERE:
    "Establishment › Transfers · Inventory › Transfers",
  CONTEXT_INTERNAL_INVOICES: "Internal invoices",
  CONTEXT_INTERNAL_INVOICES_WHERE:
    "Establishment › Internal invoices · Inventory › Internal invoices",
  CONTEXT_WEEKLY_REPORTS: "Weekly reports",
  CONTEXT_WEEKLY_REPORTS_WHERE: "Cafeteria › Weekly reports",

  TAB_ALL: "All trainings",
  TAB_MY_PATH: "My path",
  TAB_HELP_LINKS: "Help per screen",
  TAB_PATHS: "Path per role",
  TAB_FOLLOW_UP: "Employee follow-up",

  NO_HELP: "No training is available yet.",
  NO_FILES: "No file.",
  SEEN: "Seen",
  MARK_AS_SEEN: "Mark as seen",
  WATCH_TO_THE_END: "To watch to the end",
  WATCH_REQUIRED:
    "{percent} % seen · The video will be ticked automatically at the end. Fast-forward is disabled.",
  VIDEO_COMPLETED: "Video finished: it is ticked as seen.",
  SEEN_ON: "Seen on {date}",
  OPEN_IN_NEW_TAB: "Open in a new tab",
  DOWNLOAD: "Download",
  NOT_PREVIEWABLE:
    "This file cannot be shown in the browser: download it to open it.",
  CHOOSE_A_FILE: "Choose a file in the list.",

  MY_PATH_EMPTY: "No training path is planned for your role yet.",
  MY_PATH_PROGRESS: "{completed} of {total} seen",
  MY_PATH_DONE: "You have finished your training path.",

  WELCOME_TITLE: "Your training path",
  WELCOME_TEXT:
    "Videos and guides show you how to use the software. Watch them in order and tick each one once seen.",
  WELCOME_TEXT_WATCH:
    "Videos and guides show you how to use the software. Watch them in order: each video is ticked automatically once watched to the end, and you tick the guides once read.",
  WELCOME_START: "Start my training",
  WELCOME_CONTINUE: "Continue my training",
  WELCOME_LATER: "Later",

  HELP_LINKS_DESCRIPTION:
    'Choose the explorer files shown by the "?" button of each screen, in order. Replacing a file in the explorer updates the help automatically.',
  PATHS_DESCRIPTION:
    "Choose, for each role, the files a new employee must see, in order. The path shows at sign-in until everything is ticked.",
  SHOWN_ON: "Shown on: {where}",
  ADD_FILE: "Add a file",
  SEARCH_FILE: "Search an explorer file",
  MOVE_UP: "Move up",
  MOVE_DOWN: "Move down",
  REMOVE: "Remove",
  SAVED: "Changes saved",
  UNSAVED_CHANGES: "Unsaved changes",
  SELECT_ROLE: "Choose a role",
  ROLE_ACTIVE_USERS:
    "no active employee | {count} active employee | {count} active employees",
  ROLE_FILES: "no file | {count} file | {count} files",

  FOLLOW_UP_DESCRIPTION:
    "Active employees whose role has a training path. A reminder sends a notification in the software and an email.",
  NO_FOLLOW_UP: "No training path is configured yet.",
  EMPLOYEE: "Employee",
  PROGRESS: "Progress",
  FINISHED_ON: "Finished on",
  LAST_REMINDER: "Last reminder",
  REMIND: "Remind",
  REMIND_CONFIRM:
    "Send a reminder to {name}? A notification will show in the software and an email will be sent.",
  REMINDED: "Reminder sent to {name}",
  FILTER_TO_FINISH: "To finish",
  FILTER_FINISHED: "Finished",
  SEARCH_EMPLOYEE: "Search an employee",
  EXEMPT: "Exempt",
  EXEMPT_TOOLTIP: "May tick the videos without watching them in full",

  SETTINGS: "Settings",
  SETTINGS_TITLE: "Training settings",
  SETTINGS_DESCRIPTION:
    "These settings apply to every employee of the organization.",
  FORCE_VIDEO_COMPLETION: "Require watching the videos to the end",
  FORCE_VIDEO_COMPLETION_HELP:
    "Fast-forward is blocked and a video is ticked automatically at the end. Videos already ticked stay ticked. Guides (PDF, documents) are still ticked by hand.",
  EXEMPT_USERS: "Exempt employees",
  EXEMPT_USERS_HELP:
    "Employees already trained: they skip freely through the videos and tick them without watching them in full.",
  SELECT_EMPLOYEES: "Choose employees",
};
